import i18n from '../../../../i18n'

import { TemplateConfirmationInsertReplaceOptionValue } from './TemplateConfirmationModal.enums'

export function isTemplateConfirmationInsertReplaceOptionValueInsert(value) {
  return value === TemplateConfirmationInsertReplaceOptionValue.Insert
}

export function isTemplateConfirmationInsertReplaceOptionValueReplace(value) {
  return value === TemplateConfirmationInsertReplaceOptionValue.Replace
}

export function getOptions() {
  return [
    {
      id: TemplateConfirmationInsertReplaceOptionValue.Insert,
      label: i18n.t(
        'Email.ConfirmationModalInsertTemplateOptionValueOptionKey'
      ),
    },
    {
      id: TemplateConfirmationInsertReplaceOptionValue.Replace,
      label: i18n.t(
        'Email.ConfirmationModalReplaceTemplateeOptionValueOptionKey'
      ),
    },
  ]
}
